import { Box, Stack } from "@mui/material";
import ClinicalNote from "src/components/ClinicalNote";
import PatientInformation from "./components/PatientInformation";
import PatientOrders from "src/components/PatientOrders";
import Messaging from "src/components/Messaging";
import TaskHistory from "src/components/TaskHistory";
import PatientSubscriptions from "src/components/PatientSubscriptions";
import PatientIdVerification from "../PatientIdVerification";
import PatientIntakes from "src/components/PatientIntakes";
import MasonryLayout from "src/components/MasonryLayout";
import SubscriptionModalProvider from "src/context/SubscriptionModalProvider";
import PatientOrdersModalProvider from "src/context/PatientOrdersModalProvider";
import { usePatient } from "src/context/PatientProvider";
import PatientCoupons from "src/components/PatientCoupons";
import PatientIntakeModalProvider from "src/context/PatientIntakesModalProvider";
import PatientPayments from "src/components/PatientPayments";
import PatientInsurance from "../PatientInsurance";
import InvoiceModalProvider from "src/context/InvoiceModalProvider";
import SmsMessaging from "src/components/SmsMessaging";
import PatientInsuranceProvider from "src/context/PatientInsuranceProvider";

const NonProviderTaskView = () => {
  const patient = usePatient((p) => p);
  const patientGender = usePatient((p) => p.profile.gender);

  return (
    <Box overflow="scroll" padding={1}>
      <MasonryLayout spacing={1}>
        <PatientInformation patient={patient} loading={false} />
        <PatientCoupons patientId={patient.id} />
        <Messaging patientId={patient.id} />
        <SmsMessaging patient={patient} />
        <SubscriptionModalProvider
          patientId={patient.id}
          patientGender={patientGender}
        >
          <PatientSubscriptions patientId={patient.id} allowActions={true} />
        </SubscriptionModalProvider>
        <PatientOrdersModalProvider>
          <PatientOrders patient={patient} allowActions />
        </PatientOrdersModalProvider>
        <PatientIntakeModalProvider>
          <PatientIntakes
            patientId={patient.id}
            patientEmail={patient.profile.email}
            patientStatus={patient.status}
            allowActions
          />
        </PatientIntakeModalProvider>
        <PatientIdVerification patientProfileId={patient.profile_id} />
        <PatientInsuranceProvider>
          <PatientInsurance
            patientProfileId={patient.profile_id}
            allowActions
          />
        </PatientInsuranceProvider>
        <TaskHistory patientId={patient.id} />
        <InvoiceModalProvider>
          <PatientPayments patient={patient} />
        </InvoiceModalProvider>
        <Stack gap={1}>
          <ClinicalNote
            patient={patient}
            noteType={"Provider"}
            noteTitle={"PROVIDER"}
            order={1}
          />
          <ClinicalNote
            patient={patient}
            noteType={"Coordinator"}
            noteTitle={"HEALTH NAVIGATOR"}
            order={2}
          />
        </Stack>
      </MasonryLayout>
    </Box>
  );
};

export default NonProviderTaskView;
